import { Printer } from "lucide-react";
import { Button } from "./ui/button";

export function PrintButton({ label = "Print", testId = "print-btn", className = "" }) {
  return (
    <Button
      onClick={() => window.print()}
      variant="outline"
      data-testid={testId}
      className={`no-print rounded-sm border-slate-300 ${className}`}
    >
      <Printer size={16} className="mr-1.5" /> {label}
    </Button>
  );
}

export function PrintHeader({ title, subtitle }) {
  const now = new Date();
  return (
    <div className="print-only print-header">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: 16 }}>
        <div style={{ display: "flex", alignItems: "flex-end", gap: 12 }}>
          <img
            src="/jc-logo.webp"
            alt="Just Compare"
            style={{ height: 44, width: "auto", objectFit: "contain" }}
          />
          <div>
            <div style={{ fontSize: 10, letterSpacing: "0.25em", fontWeight: 700, textTransform: "uppercase", color: "#003399" }}>
              Just Compare · Educational & Office Supply
            </div>
            <div style={{ fontFamily: "Chivo, sans-serif", fontSize: 24, fontWeight: 900, letterSpacing: "-0.02em", marginTop: 4 }}>
              {title}
            </div>
            {subtitle && (
              <div style={{ fontSize: 12, color: "#475569", marginTop: 2 }}>{subtitle}</div>
            )}
          </div>
        </div>
        <div style={{ fontSize: 11, fontFamily: "IBM Plex Mono, monospace", color: "#475569" }}>
          Printed {now.toLocaleString()}
        </div>
      </div>
    </div>
  );
}
